import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LoadingFade from "../../LoadingFade";
import {useState, useEffect, useRef, createRef, useCallback } from "react";
import {useNavigate, useParams} from "react-router-dom";
import httpService from "../../../services/httpService";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import Heading3 from "../../Heading3";
import SkillButton from "../SkillButton";
import Collapse from "react-bootstrap/Collapse";
import {FaRegTrashAlt} from "react-icons/fa";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {Modal, Spinner} from "react-bootstrap";
import Cropper from 'react-easy-crop';
import eventBus from "../../../services/eventBus";
import Image from "react-bootstrap/Image";
import { useUiStore } from "../../../store/store";

const StepChoice = ({onStageChange, onClubChange, podcastClub}) => {
    const { step, id } = useParams();
    const navigate = useNavigate();
    const [pageLoading, setPageLoading] = useState(true);
    const [clubLoading, setClubLoading] = useState(false);
    const { setShowPodcasterPodcastClubOnboardingVideo } = useUiStore();

    useEffect(() => {
        setPageLoading(false);
    }, [podcastClub]);

    const goToNextStep = (guid = null) => {
        setPageLoading(true)
        onStageChange('start', guid)
    };

    const createSamplePodcastClub = async () => {
        const res = await httpService.post('dash/sample-podcast-club');
        return res.data.podcast_club.guid
    };

    const goToClubDashboard = async () => {
        setClubLoading(true)
        let guid = await createSamplePodcastClub()
        setPageLoading(true)
        setShowPodcasterPodcastClubOnboardingVideo(true);
        navigate(`/podcaster/podcast-club/${guid}`)
    };

    return(
        <LoadingFade loading={pageLoading} stateKey={pageLoading?'loading':'not-loading'}>
            <Row className={'pb-3'}>
                {clubLoading ? (
                    <Col sm={12} className="d-flex justify-content-center">
                        <div className="d-flex flex-column align-items-center" style={{width: '100%'}}>
                            <div className="w-50 d-block my-5 p-3" role="status">
                                <Image src={'/img/podsy-loader.gif'} fluid />
                            </div>
                            <div>
                                <h3>Creating your club, it may take a moment</h3>
                            </div>
                        </div>
                    </Col>
                ) : (
                    <Col sm={12}>
                        <h2>What would you like to do first?</h2>
                        <Card className={"p-3"}>
                            <h3>Explore a working Podcast Club (recommended)</h3>
                            <p>See how listeners interact, create practices, and join discussions.</p>
                            <button className="btn btn-primary w-25" onClick={() => goToClubDashboard()}>
                                Go to dashboard
                            </button>
                        </Card>
                        <Card className={"p-3 mt-3"}>
                            <h3>Build your own Podcast Club</h3>
                            <p>Start setting up your club to understand the look and feel with your own content.</p>
                            <button className="btn btn-primary w-25" onClick={() => goToNextStep()}>
                                Go to Podcast Club wizard
                            </button>
                        </Card>
                    </Col>
                )}
            </Row>
        </LoadingFade>
    )
}

export default StepChoice;